import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../utils';
import '../../CSS/style.css';

class Content extends React.PureComponent {

  selectTab = () => {
    sessionStorage.setItem("activeTab","ABI平台")
  };
  render() {
    const { dataSource, isMobile, ...props } = this.props;
    const {
      wrapper,
      titleWrapper,
      page,
      OverPack: overPackData,
      childWrapper,
    } = dataSource;


    return (
      <div {...props} {...wrapper} style={{background:'#fff'}}>
        <div {...page}>
          <div {...titleWrapper} style={{fontSize:16,color:'rgba( 0, 0, 0, 0.85)'}}>
            <Link to={titleWrapper.url} onClick={() => this.selectTab()}>
              <Row type="flex" justify="center">
                <div className="home_title">
                  {titleWrapper.children.map(getChildrenToRender)}
                </div>
              </Row>
            </Link>
          </div>
          <OverPack {...overPackData}>
            <Row type="flex" justify="space-between">
              {childWrapper.children.map((block, i) => {
                const { children: item, ...blockProps } = block;
                return (
                    <Col key={i.toString()} {...blockProps}>
                      <div {...item}>
                        <Link to={{ pathname: '/product' , state: { name: item.positions }}} onClick={this.selectTab} style={{color:'#919191'}}>
                          {item.children.map(getChildrenToRender)}
                        </Link>
                      </div>
                    </Col>
                );
              })}
            </Row>
          </OverPack>
        </div>
      </div>
    );
  }
}

export default Content;
